import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLanguageContext } from './LanguageContext';
import styles from './LanguageSwitcher.module.css';
import { useSetLanguageMutation } from './rekisterointiApi';
export function LanguageSwitcher() {
    const { language } = useLanguageContext();
    const [setLanguageMutation, { isLoading }] = useSetLanguageMutation();
    const onChange = async (lang) => {
        await setLanguageMutation(lang).unwrap();
    };
    return (_jsxs("div", { className: styles.languageSwitcher, children: [_jsx("button", { className: `${styles.languageButton} ${styles.leftButton}`, onClick: () => onChange('fi'), disabled: language === 'fi' || isLoading, children: "Suomeksi" }), _jsx("button", { className: `${styles.languageButton} ${styles.rightButton}`, onClick: () => onChange('sv'), disabled: language === 'sv' || isLoading, children: "P\u00E5 svenska" })] }));
}
